import { PapiDeviation } from '@wix/da-papi-types';
import { createAction } from 'redux-actions';
import { actionTypePrefix } from './constants';

export type PollVotePayload = {
  pollId: number;
  userId: number;
  answerId: number;
};

export type PollVoteSuccessPayload = {
  pollId: number;
  userId: number;
  answerId: number;
  poll?: PapiDeviation;
};

export const voteInPoll = createAction(
  `${actionTypePrefix}.POLL_VOTE`,
  (payload: PollVotePayload) => payload
);

export const voteInPollFail = createAction(
  `${actionTypePrefix}.POLL_VOTE_FAIL`,
  (payload: PollVotePayload) => payload
);

export const voteInPollSuccess = createAction(
  `${actionTypePrefix}.POLL_VOTE_SUCCESS`,
  (payload: PollVoteSuccessPayload) => payload
);
